import { gql } from "@apollo/client";

export const LOAD_PROPERTY_CONTRACT_PROGRESS = gql`
  query PropertyContractProgress {
    propertyContractProgress {
      submissionId
      stepIndex
      valuesJson
    }
  }
`;

export const CREATE_PROPERTY_CONTRACT = gql`
  mutation CreatePropertyContract($data: CreatePropertyContractInput!) {
    createPropertyContract(data: $data) {
      id
      signUrl
      signatureRequestId
    }
  }
`;

export const SAVE_PROPERTY_CONTRACT_PROGRESS = gql`
  mutation SavePropertyContractProgress($data: SavePropertyContractProgressInput!) {
    savePropertyContractProgress(data: $data) {
      submissionId
    }
  }
`;

export const CANCEL_PROPERTY_CONTRACT = gql`
  mutation CancelPropertyContract($signatureRequestId: TrimmedId!) {
    cancelPropertyContract(signatureRequestId: $signatureRequestId)
  }
`;

export const SEND_PROPERTY_QUOTE_EMAIL = gql`
  mutation SendPropertyQuoteEmail($data: SendPropertyQuoteEmailInput!) {
    sendPropertyQuoteEmail(data: $data)
  }
`;


